import { AlkLogger } from '@alk/core';
import { ColDef, GridOptions } from '@ag-grid-community/core';
import { EBlotterTab } from '../../../enums';
import { IKondorBlotterService } from './kondor-blotter.interface';
import { IKondorRow } from '../../../interfaces';
import { injectable } from 'inversify';
import { Observable, of, Subject } from 'rxjs';

@injectable()
export class KondorBlotterMock implements IKondorBlotterService {
    type = 'kondor' as EBlotterTab;
    isRowActionsEnabled: boolean;

    gridOptions(): GridOptions {
        AlkLogger.debug('[KondorBlotterMock#gridOptions]');
        return {} as GridOptions;
    }

    ordersObservable(): Observable<IKondorRow> {
        AlkLogger.debug('[KondorBlotterMock#ordersObservable]');
        return (new Subject<IKondorRow>()).asObservable();
    }

    columnDefinitions(): Observable<Array<ColDef>> {
        AlkLogger.debug('[KondorBlotterMock#columnDefinitions]');
        return of([]);
    }

    init(): Promise<void> {
        AlkLogger.debug('[KondorBlotterMock#init]');
        return Promise.resolve(undefined);
    }

    stop(): void {
        AlkLogger.debug('[KondorBlotterMock#stop]');
    }

    clearObservable(): Observable<void> {
        return (new Subject<void>()).asObservable();
    }
}
